<h1>Storage Alerting <span *ngIf="label">- {{label}}</span>
  <a [href]="url" target="_blank" class="float-right heading-icon">
    <i class="fas fa-info-circle" alt="More info about alerting" title="More info about the alerting"></i>
  </a>
</h1>